<template>
    <div class="home">
        <div class="cBox">
            <div>
                <div class="product">
                    <div>
                        <div>产品分类</div>
                        <div><i class="el-icon-d-arrow-right"></i></div>
                    </div>
                    <div class="productItem" v-for="(item,index) in productList" :key="index">
                        <div>
                            <div>{{item.tagName}}</div>
                        </div>
                        <div class="ellipsis">
                            <div v-for="(i,n) in item.byProducts" :key="n" @click="screenProduct(i)">
                                {{i.name}}
                                <!-- <div v-for="(j,x) in i.pushFacMids" :key="x" @click="screenProduct(i,j)">{{i.name}}
                                    {{j.facCateName}}</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <!-- 意向卖货 -->
                <div class="yxmh">
                    <div class="box title">
                        <div class="fz18">所有产品</div>
                        <div class="fz14"></div>
                    </div>
                    <div class="list">
                        <div class="item_2" v-for="(commodity,key) in newList" :key="key" @click="goDetails(commodity)">
                            <div :class="'status_'+commodity.status">
                                <span v-if="commodity.status=='1'">进行中</span>
                                <span v-if="commodity.status=='2'">停售中</span>
                                <span v-if="commodity.status=='3'">已结束</span>
                            </div>
                            <div class="ellipsis">{{commodity.title}}{{commodity.productMsg?'·'+commodity.productMsg:''}}</div>
                            <div>
                                <div class="ellipsis"><i
                                        class="iconC el-icon-office-building"></i>{{$store.state.orgName}}
                                </div>
                                <!-- <div>{{commodity.location}}</div> -->
                            </div>
                            <div>
                                <div>总量<span class="blue">{{commodity.amount}}</span>{{commodity.numUnit}}</div>
                                <div>更新时间 {{commodity.startDate|homeTime}}</div>
                            </div>
                            <div v-if="commodity.typeName=='意向卖货'">
                                <label v-if="commodity.priceOne/1!=0">底价</label>
                                <span class="origin fz22" v-if="commodity.priceOne/1!=0">¥</span>
                                <span class="origin fz32">{{commodity.priceOne/1==0?'面议':commodity.priceOne/1}}</span>
                                <span class="origin fz16" v-if="commodity.priceOne/1!=0">/{{commodity.unitedTitle}}</span>
                            </div>
                            <div v-if="commodity.typeName=='抢购'">
                                竞拍底价
                                <span
                                    class="green fz20">¥{{commodity.modeName=='明拍'?commodity.priceOne/1:(commodity.status=='2'?commodity.priceOne/1:'???')}}</span>
                                /{{commodity.unitedTitle}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page">
                    <el-pagination @current-change="handleCurrentChange" background :current-page="pageNum"
                        :page-size="18" layout="prev, pager, next" :total="total">
                    </el-pagination>
                    <input type="text" name="" id="" v-model="num" />
                    <el-button size="mini" style="margin-left: 16px;" @click="inputCurrentChange">跳转</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Home",
        data() {
            return {
                newList: [],
                productList: [],

                product: '',
                pageNum: 1,
                num: null,
                total: 0,
            }
        },
        created() {
            this.init();
        },
        methods: {
            goDetails(commodity) {
                let that = this;
                commodity.showType = commodity.typeName;
                commodity.biddingMode = commodity.modeName;
                commodity.pendingWay = commodity.modeName;

                if (!that.$store.state.userId) {
                    that.goRouter('/login');
                    return;
                }

                if (commodity.showType == '抢购') {
                    if (commodity.biddingMode == '明拍') {
                        if (commodity.userId == that.$store.state.userId) {
                            that.$router.push({
                                path: '/shop_jp_details_sell',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        } else {
                            that.$router.push({
                                path: '/shop_jp_details_buy',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        }
                    } else {
                        if (commodity.userId == that.$store.state.userId) {
                            that.$router.push({
                                path: '/shop_jp_details_sell',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        } else {
                            that.$router.push({
                                path: '/shop_jp_details_buy',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        }
                    }
                }

                if (commodity.showType == '意向卖货') {
                    if (that.$store.state.userId == commodity.userId) { //卖家
                        that.$router.push({
                            path: '/shop_yxmh_details_sell',
                            query: {
                                commodityId: commodity.id
                            }
                        });
                    } else { //买家
                        this.$router.push({
                            path: '/shop_yxmh_details_buy',
                            query: {
                                commodityId: commodity.id
                            }
                        });
                    }
                }
            },
            init() {
                this.getNew();
                this.getProduct();
            },
            screenProduct(i, j) {
                this.product = i.name;
                this.pageNum = 1;
                this.getNew();
            },
            inputCurrentChange() {
                if (!this.num) {
                    return;
                }
                this.pageNum = this.num / 1;
                this.getNew();
            },
            handleCurrentChange(pageNum) {
                this.pageNum = pageNum;
                this.getNew();
            },
            getNew() {
                let params = {
                    pageNum: this.pageNum,
                    pageSize: 18,
                    brtNum: this.$store.state.orgCode,
                    type: 2,
                    dealType: 'B,YXMH'
                }
                if (this.product) {
                    params.product = this.product;
                }
                this.getList(params);
            },
            getList(params) {
                this.request.get(this.$store.state.httpUrl + "new/h5/queryCommodityListTradeH5", {
                    params: params
                }).then(res => {
                    if (res.status == 200) {
                        this.newList = res.data;
                        this.total = res.total;
                    }
                });
            },
            getProduct() {
                this.request.get(this.$store.state.ryHttpUrl + "product/getProducts", {
                    params: {
                        businessNo: this.$store.state.orgCode
                    }
                }).then(res => {
                    if (res.status) {
                        this.productList = res.pageData;
                        this.$store.state.productList = res.pageData;
                    }
                });
            },
        }
    };
</script>

<style scoped>
    .home {
        background: #E5ECF9;
        text-align: left;
    }

    .product {
        padding-bottom: 24px;
    }

    .product>div {
        padding: 0 24px;
        box-sizing: border-box;
    }

    .product>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        width: 240px;
        height: 48px;
        line-height: 48px;
        background: linear-gradient(90deg, #D50000, #EB2B2B);
        border-radius: 10px 10px 0px 0px;
        color: #FFFFFF;
    }

    .product>div:nth-child(1)>div>i {
        color: #FFFFFF;
    }

    .productItem>div:nth-child(1) {
        font-size: 14px;
        color: #333333;
        margin-top: 14px;
    }

    .productItem>div:nth-child(2)>div,
    .productItem>div:nth-child(2)>div>div {
        font-size: 12px;
        color: #999999;
        margin-top: 12px;
        cursor: pointer;
    }

    .productItem>div:nth-child(2)>div:hover{
        color: #D50000;
    }

    .cBox {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
    }

    .cBox>div:nth-child(1),
    .cBox>div:nth-child(1)>div {
        width: 240px;
    }

    .cBox>div:nth-child(1)>div {
        background: #FFFFFF;
        border-radius: 10px;
        margin-bottom: 20px;
    }

    .cBox>div:nth-child(1)>.cBL {
        padding: 0 24px;
        box-sizing: border-box;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1) {
        height: 48px;
        line-height: 46px;
        border-bottom: 1px solid #CCCCCC;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1)>div:nth-child(1) {
        color: #D50000;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1)>div:nth-child(1)>i {
        font-size: 16px;
        margin-right: 12px;
        vertical-align: middle;
    }

    .cBox>div:nth-child(1)>.cBL>div:nth-child(1)>div:nth-child(2) {
        color: #666666;
        cursor: pointer;
    }

    .user {
        width: 240px;
        height: 172px;
        text-align: center;
        padding-top: 24px;
        box-sizing: border-box;
    }

    .cBox>div:nth-child(2) {
        width: 936px;
    }

    .boutique {
        padding-bottom: 30px;
    }

    .title {
        display: flex;
        justify-content: space-between;
        border-bottom: 2px solid #D50000;
        height: 39px;
        box-sizing: border-box;
    }

    .title>div:nth-child(1) {
        width: 108px;
        height: 38px;
        line-height: 38px;
        background: linear-gradient(90deg, #D50000 0%, #FF6969 100%);
        border-radius: 0px 20px 0px 0px;
        font-size: 16px;
        text-align: center;
        color: #FFFFFF;
    }

    .title>div:nth-child(2) {
        font-size: 14px;
        cursor: pointer;
    }

    .yxmh>div {
        width: 936px;
        margin: 0 auto;
    }

    .list>div {
        cursor: pointer;
        position: relative;
        margin-top: 20px;
    }

    .list>div:last-child {
        margin-right: 0 !important;
    }

    .yxmh .list {
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-between; */
        position: relative;
        z-index: 2;
    }

    .yxmh .list>div {
        width: 288px;
        height: 202px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(34, 86, 193, 0.18);
        border-radius: 10px;
        padding: 28px 26px 0 26px;
        box-sizing: border-box;
        position: relative;
        margin-right: 36px;
    }


    .yxmh .list>div:nth-child(3n){
        margin-right: 0;
    }

    .item_2>div {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        text-align: left;
    }

    .item_2>div:nth-child(1) {
        position: absolute;
        right: 0;
        top: 12px;
        width: 72px;
        height: 26px;
        line-height: 26px;
        border-radius: 13px 0px 0px 13px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
    }

    .item_2>.status_1,
    .item_2>.status_1>span {
        color: #729BFF;
        background: #E4EEFF;
    }

    .item_2>.status_2,
    .item_2>.status_2>span {
        color: #FF8C25;
        background: #FFE3A6;
    }

    .item_2>.status_3,
    .item_2>.status_3>span {
        color: #90A4D0;
        background: #E3E8F2;
    }

    .item_2>div:nth-child(2) {
        font-size: 20px;
        font-weight: 600;
        color: #333333;
    }

    .item_2>div:nth-child(3) {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #CCDDFF;
        padding: 18px 0;
    }

    .item_2>div:nth-child(4) {
        display: flex;
        justify-content: space-between;
        padding: 12px 0 24px 0;
    }

    .item_2>div:nth-child(5)>span {
        font-weight: bold;
    }

    .item_2>div>div:nth-child(2) {
        color: #999999;
    }
</style>



// WEBPACK FOOTER //
// src/view/shop/productShop.vue